import { useApp } from '../context/AppContext';
import { useTranslation } from 'react-i18next';
import Haptics from '../utils/haptics';

const IOSInstallPrompt = () => {
    const { isIOS, showIOSInstallGuide, setShowIOSInstallGuide } = useApp();
    const { t } = useTranslation();
    const isChromeIOS = navigator.userAgent.includes('CriOS');

    if (!isIOS || !showIOSInstallGuide) {
        return null;
    }

    const getShareIcon = () => {
        if (isChromeIOS) {
            return (
                <svg className="w-5 h-5 mx-auto text-gray-700 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 12V6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5V12M12 18V8m0 10l3-3m-3 3l-3-3" />
                </svg>
            );
        }
        // Safari Share Icon
        return (
            <svg className="w-5 h-5 mx-auto text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v10m0 0l3-3m-3 3l-3-3m9-10h.01M5 10h.01M21 10h-2M3 10h2M12 3v2" />
            </svg>
        );
    };
    
    const handleClose = () => {
        Haptics.tap();
        setShowIOSInstallGuide(false);
    }

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-end pwa-install-prompt" 
            onClick={handleClose}
        >
            <div 
                className="bg-white dark:bg-gray-800 rounded-t-2xl shadow-2xl w-full max-w-md mx-auto p-6 pt-5 text-center transform transition-transform duration-300" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="w-12 h-1.5 bg-gray-300 dark:bg-gray-600 rounded-full mx-auto mb-4"></div>
                <div>
                    <h3 className="font-black text-gray-900 dark:text-white text-lg mb-1 tracking-tight">
                        {t(isChromeIOS ? 'install_chrome_ios' : 'install_safari_ios')}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mb-6 px-4 leading-relaxed font-medium">
                        {t('install_ios_desc')}
                    </p>
                    <ol className="text-sm text-gray-800 dark:text-gray-200 space-y-4 text-left px-2">
                        <li className="flex items-center">
                            <span className="font-bold text-lg text-blue-600 dark:text-blue-400 mr-3">{t('new_1_')}</span>
                            <span>{t('install_ios_step1')} {getShareIcon()}</span>
                        </li>
                        <li className="flex items-center">
                            <span className="font-bold text-lg text-blue-600 dark:text-blue-400 mr-3">{t('new_2_')}</span>
                            <span>{t('install_ios_step2')}</span>
                        </li>
                        <li className="flex items-center">
                            <span className="font-bold text-lg text-blue-600 dark:text-blue-400 mr-3">{t('new_3_')}</span>
                            <span>{t('install_ios_step3')}</span>
                        </li>
                    </ol>
                </div>
                <button 
                    onClick={handleClose} 
                    className="mt-6 bg-blue-600 text-white font-bold py-2 px-8 rounded-full w-full max-w-xs mx-auto text-base"
                >
                    {t('done')}
                </button>
            </div>
        </div>
    );
};

export default IOSInstallPrompt;